export default "__VITE_ASSET__CmGjgBQU__"